import { TreatmentProgram } from 'global.constants'

import { apiClient } from '~services/apiClient'

interface ELID {
  companyId?: number
  slugCompanyId?: number
  dateOfBirth: string
  firstName?: string
  lastName: string
  province?: string
  postalCode: string
  accessCode?: string
}

interface EligibilityResponse {
  companyId: number
  success: boolean
  treatmentPrograms?: Partial<
    Record<
      TreatmentProgram,
      {
        eligible: boolean
        accessCode?: string
      }
    >
  >
}

/**
 * Fetch a user's record from the general eligibility endpoint
 */
export default function fetchCompanyEligibility(elid: ELID) {
  const url = '/b2b-user-onboarding/check-eligibility'
  return apiClient.put<EligibilityResponse>(url, {
    DOB: elid.dateOfBirth,
    firstName: elid.firstName,
    lastName: elid.lastName,
    ZIP: elid.postalCode,
    ...(!!elid.companyId &&
      // for partnership (identified by slugCompanyId),
      // id of employer company should not be sent when access code is provided
      // because the access code is unique to the partnership
      // and should override wrong company selection
      (!elid.slugCompanyId || !elid.accessCode) && {
        companyId: elid.companyId.toString(),
      }),
    ...(!!elid.slugCompanyId && { slugCompanyId: elid.slugCompanyId }),
    ...(!!elid.province && { state: elid.province }),
    ...(!!elid.accessCode && { accessCode: elid.accessCode }),
  })
}
